import apiHandler from "../../components/Defaults/ApiHandler";
import axios from "axios";

export const adminAuth = (callback, errorCallback) => {
    const config = {
        url: '/api/admin/auth',
        method: "GET"
    }
    apiHandler("Getting Auth", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}
